// extracted by mini-css-extract-plugin
export default {"icon":"Options-module__icon--My0uy","dropdown":"Options-module__dropdown--pckP_","option":"Options-module__option--Ft6Gb"};